import { Children, ReactElement, useRef } from 'react';
import { AccordionItemButton } from './AccordionItemButton';
import { DefaultAccordionItemButton } from './defaultElements/DefaultAccordionItemButton';
import { IAccordionItemProps } from './AccordionItem';
import AnimateHeight from 'react-animate-height';
import { useAccordionContext } from './context';
import { Box } from '@apia/theme';
import { customEvents } from '@apia/util';

export const AccordionItemContent = ({
  children,
  buttonProps,
}: IAccordionItemProps) => {
  let button = null;

  const actualChildren = Children.toArray(children).filter((current) => {
    if (typeof current !== 'string' && typeof current !== 'number') {
      const element = current as ReactElement;

      if (element.type === AccordionItemButton) {
        button = element;
        return false;
      }
    }
    return true;
  });

  if (button === null && buttonProps)
    button = <DefaultAccordionItemButton {...buttonProps} />;

  const handler = useAccordionContext();
  const isExpanded = handler.hooks.useItemStateSelector(
    (current) => current.isExpanded,
  );
  const id = handler.hooks.useItemId();

  const duration = handler.hooks.usePropsSelector(
    (current) => current.animationDuration,
  );

  const uns = useRef(() => {});

  return (
    <Box
      className="accordion__item"
      data-id={id}
      data-test-id={id}
      ref={(el) => {
        uns.current();
        if (el instanceof HTMLElement) {
          const handleFocus = () => {
            handler.toggleItem(id, true);
          };
          el.addEventListener(customEvents.focus, handleFocus);
          uns.current = () => {
            el.removeEventListener(customEvents.focus, handleFocus);
          };
        }
      }}
    >
      {button}
      <AnimateHeight
        className={`accordion__item__content ${isExpanded ? ' expanded' : ''}`}
        height={isExpanded ? 'auto' : 0}
        duration={duration}
        id={`accordion__${handler.id}__${id}`}
      >
        {actualChildren}
      </AnimateHeight>
    </Box>
  );
};
